import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Text from '../../common/component/Text';
import useWindowSize from '../../common/hook/useWindowSize';

interface IProps {
  excludingSize: number;
  textKey: string;
  className?: string;
  textClassName?: string;
}

export default function ListEmptyContent({
  textKey,
  textClassName = 's16-regular-grey08',
  className,
  excludingSize,
}: IProps) {
  const {t} = useTranslation();
  const [style, setStyle] = useState({});
  const {height} = useWindowSize();

  useEffect(() => {
    setStyle({height: `${height - excludingSize}px`});
  }, [height, excludingSize]);

  return (
    <Text
      style={style}
      className={cn('flex-center w-full text-center', className, textClassName)}
    >
      {t(textKey)}
    </Text>
  );
}
